const SDK_VERSION = '8.26.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
